import React from 'react';
import FieldMultiselect from "../multiselect";
import FieldMultiselect_Pill from "../components/pill";

export type FieldMultiselectViewSmallProps = {
    field       : FieldMultiselect;
    model       : any;
    className?  : string;
    onClick?    : onClick,
    width?      : number
};

export default function FieldMultiselect_ViewSmall(props:FieldMultiselectViewSmallProps) {

    const value     = _.get(props.model, props.field.fieldId, null)
    const valueOptions   = props.field._getOptions(value)

    if (!valueOptions) return false;


    let optionsToShow = valueOptions.length;
    let moreOptions = 0;
    const pillMaxWidth = 80;
    if (!_.isNil(props.width)) {
        optionsToShow = Math.floor(props.width/pillMaxWidth);
        moreOptions = valueOptions.length - optionsToShow;
    }

    const more = !!moreOptions ? <div className="ui5-link-default">{"{0}{1}".f(optionsToShow > 0 ? '+' : '', moreOptions)}</div> : null;

    return (
        <React.Fragment>
            {_.map(valueOptions, (option, key) => {
                if (key >= optionsToShow) return;
                return <props.field.components.Pill key={option.value}
                                                    className="m-r-4"
                                                    option={option}
                                                    style={{maxWidth: pillMaxWidth}}
                                                    onClick={props.onClick}
                />
                // return <FieldMultiselect_Pill key={option.value} className="m-r-4" style={{maxWidth: pillMaxWidth}} size="22" option={option} onClick={props.onClick}/>
            })}

            {more}
        </React.Fragment>
    );

}
